import type { ExportDisclosureDTO } from '../service/ai-disclosure.repository.interface';
import type { ExportDisclosureRequest } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ExportDisclosure } from '@/infrastructure/api-functions/interface/export-disclosure.interface';

@injectable()
export class ExportDisclosureDTOImpl implements ExportDisclosureDTO {
    constructor(
        @inject(ExportDisclosure)
        private readonly _exportDisclosureApi: ExportDisclosure
    ) {
    }

    async fetch(value: ExportDisclosureRequest): Promise<string> {
        const params = {
            task_id: value.taskId,
            title: value.title,
            data: value.data.map((item) => ({
                title: item.title,
                content: item.content,
                parent_title: item.parentTitle || item.title,
            })),
        };
        return await this._exportDisclosureApi.exportDisclosure(params);
    }
}
